import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getFortalezaStartService,
  getFortalezaCurrentService,
  sendFortalezaAnswerService,
  getFortalezaStatusService,
  getFortalezasCompletadasService,
  getFortalezaSummaryService,
} from "../../services/fortalezas/fortalezaTalentos.service";

export const getFortalezaStartThunk = createAsyncThunk(
  "fortalezaTalentos/getStart",
  async (_, { rejectWithValue }) => {
    try {
      return await getFortalezaStartService();
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          "Error al obtener el estado de fortalezas"
      );
    }
  }
);

export const getFortalezaCurrentThunk = createAsyncThunk(
  "fortalezaTalentos/getCurrent",
  async (_, { rejectWithValue }) => {
    try {
      return await getFortalezaCurrentService();
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Error al obtener el área actual"
      );
    }
  }
);

export const sendFortalezaAnswerThunk = createAsyncThunk(
  "fortalezaTalentos/sendAnswer",
  async (payload, { rejectWithValue }) => {
    try {
      return await sendFortalezaAnswerService(payload);
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Error al enviar la respuesta"
      );
    }
  }
);

export const getFortalezaStatusThunk = createAsyncThunk(
  "fortalezaTalentos/getStatus",
  async (_, { rejectWithValue }) => {
    try {
      return await getFortalezaStatusService();
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          "Error al obtener el estado de fortalezas"
      );
    }
  }
);

export const getFortalezasCompletadasThunk = createAsyncThunk(
  "fortalezaTalentos/getCompletadas",
  async (_, { rejectWithValue }) => {
    try {
      return await getFortalezasCompletadasService();
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          "Error al obtener las fortalezas completadas"
      );
    }
  }
);

export const getFortalezaSummaryThunk = createAsyncThunk(
  "fortalezaTalentos/getSummary",
  async (_, { rejectWithValue }) => {
    try {
      return await getFortalezaSummaryService();
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Error al obtener el resumen"
      );
    }
  }
);
